<template>
  <div
    :class="!expandUVS ? 'md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50' : 'md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100'"
    style="z-index: 2"
  >
    <md-card>
      <md-card-header data-background-color="newyellow">
        <div style="display: flex; justify-content: space-between;align-items: center;">
          <h5 class="tittle">Usuários conectados por versão de sistema</h5>
          <font-awesome-icon
            v-show="expandUVS"
            @click="expandUVS=false"
            style="cursor: pointer;"
            icon="times-circle"
          />
        </div>
      </md-card-header>
      <md-card-content style="min-height:475px; height: auto;  ">
        <div style="display: flex; justify-content: space-around;">
          <v-progress-circular v-if="loadingByReturns" :size="100" :width="3" color="#2A5377" style="justify-content: center; align-itens: center;"
              indeterminate>
          </v-progress-circular>        
          <div :class="!expandUVS ? 'graphcontent' : 'graphcontent2'" v-else>
            <apexchart
              v-if="series.length != 0"
              type="pie"
              width="500"
              height="400"
              :options="chartOptions"
              :series="series"
            />

            <div v-else class="nographic">
              <div class="alerta" style="margin:0px!important;">
                <font-awesome-icon
                  icon="exclamation-circle"
                  style="margin-right: 8px;margin-left:8px;"
                />Sem dados disponíveis
              </div>
            </div>
            <v-radio-group
              style="width: 100%;    justify-content: center;
    display: flex;"
              row
              v-model="sistemaAtual"
              @change="initGraphics"
            >
              <v-radio label="Agro" value="2"></v-radio>
              <v-radio checked label="Neo" value="9"></v-radio>
              <v-radio label="Neo NFC-e" value="11"></v-radio>
            </v-radio-group>
          </div>
        </div>
        <transition>
          <div v-if="expandUVS">
            <div style="display: flex;
    justify-content: flex-start;
    align-items: center;">
              <div style="border-left: 5px solid #2b5577;padding-left:10px">
                <h4>
                  <b>Clientes conectados por versão:</b>
                </h4>
                <p>Segure shift para selecionar várias versões</p>
              </div>
              <div style="margin: 40px">
                <v-chip
                  style="color: #fff"
                  color="#2b5577"
                  close
                  v-for="versao in versaoAtual"
                  :key="versao.CLISISVERSAOATUAL"
                  @input="removeVersao(versao)"
                >{{versao.CLISISVERSAOATUAL}}</v-chip>
              </div>
            </div>
            <Clientes @filters="filtering" v-if="clientesExibir && versaoAtual" :versoes="versaoAtual" :atividades="atividades" :personas="personas" :analistas="analistas" :arquivos="arquivos" />
            <div class="alerta" v-else>
              <font-awesome-icon
                icon="exclamation-circle"
                style="margin-right: 8px;margin-left:8px;"
              />Você deve selecionar uma versão para exibição
            </div>
          </div>
        </transition>
      </md-card-content>
    </md-card>
    <md-snackbar :md-active.sync="msg">{{msg}}</md-snackbar>
  </div>
</template>
<script>

import * as GraficosService from "../../providers/graficos.service";
import * as ArquivosService from "../../providers/arquivos.service";
import Clientes from "../Clientes/tabelaClientes";

var jwt = require("jsonwebtoken");

export default {
  components: {
    Clientes
  },
  created() {
    var self = this;
debugger;
    var fUser = jwt.decode(localStorage.getItem("token"));
  
    self.sistemaAtual = fUser.SEGCODIGO.includes("1") ? "9" : "2";

    self.nivelVersao = 4;
    self.loadingByReturns = true;

    ArquivosService.getArquivosDescontinuados(self.sistemaAtual).then(r => {
      self.versoesDescontinuadas = r.Rows.map(el => { 
          return el.ARQDESVERSAO;
        });
      self.initGraphics(self.sistemaAtual, true, self.body);
      self.mestreInterval = setInterval(() => {
        self.initGraphics(self.sistemaAtual, false, self.body);
      }, 20000);        
    });
  },
  beforeDestroy() {
    clearInterval(this.mestreInterval);
  },
  watch: {
    sistemaAtual: function(val) {
      this.refreshFilter();
    },
    atividades: function(val) {
      this.refreshFilter();
    },
    personas: function(val) {
      this.refreshFilter();
    },
    analistas: function(val) {
      this.refreshFilter();     
    },
    arquivos: function(val) {
      this.refreshFilter();     
    }
  },
  props: {
    atividades: {
      type: Array()
    },
    personas: {
      type: Array()
    },
    analistas: {
      type: Array()
    },
    arquivos: {
      type: Array()
    }    
  },
  data() {
    var self = this;
    return {
      msg: false,
      mestreInterval: false,
      versoesDescontinuadas: [],
      originalVersaoArr: [],
      body: {
        filter: false,
        versoes: false,
        versoesEMS: false,
        filterBloqueados: false,
        aplicativo: false
      },
      clientesExibir: false,
      sistemaAtual: false,
      nivelVersao: 4,
      dataAtualizacao: new Date(),
      expandUVS: false,
      versaoAtual: Array(),
      series: [],
      loadingByReturns: true,
      chartOptions: {
        labels: [],
        dataLabels: {
          formatter: function (val, opts) {
            return [val.toFixed(1) + "%", self.series[opts.seriesIndex]]
          },
        },
        chart: {
          events: {
            dataPointSelection: function(event, chartContext, config) {
              self.grafSelect(event, chartContext, config);
            },
            legendClick: function(chartContext, seriesIndex, config) {
              config.dataPointIndex = seriesIndex;
              self.grafSelect(event, chartContext, config);
            }
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              zoom: true,
              zoomin: true,
              zoomout: true,
              download: false,
              customIcons: [                
                {
                  //icon: '<img src="https://i.im.ge/2021/08/12/jtLAp.png" width="20" height="20" />' ,
                  icon: '<p width="50">x.x</p>',
                  index: 0,
                  title: 'minor',
                  class: 'custom-icon-rs',
                  click: function (chart, options, e) {                     
                    self.loadingByReturns = true;
                    self.nivelVersao = 2;

                    self.filtering(self.body);
                  }
                },
                {
                  //icon: '<img src="https://i.im.ge/2021/08/12/jtI7q.png" width="20" height="20" />' ,
                  icon: '<p width="50">x.x.x</p>',
                  index: 1,
                  title: 'release',
                  class: 'custom-icon-rs',
                  click: function (chart, options, e) {
                    self.loadingByReturns = true;
                    self.nivelVersao = 3;

                    self.filtering(self.body);
                  }
                },
                {
                  //icon: '<img src="https://i.im.ge/2021/08/12/jt7GC.png" width="20" height="20" />' ,
                  icon: '<p width="50">x.x.x.x</p>',
                  index: 2,
                  title: 'build',
                  class: 'custom-icon-rs',
                  click: function (chart, options, e) {
                    self.loadingByReturns = true;
                    self.nivelVersao = 4;

                    self.filtering(self.body);
                  }
                } 
              ]
            }
          }
        },
        expandOnClick: false,
        colors: [
          function({value, seriesIndex, w}){
            if (self.versoesDescontinuadas.includes(self.chartOptions.labels[seriesIndex]))
              return "#FF6666";
            else if (seriesIndex == self.chartOptions.labels.length - 1)
              return "#FFBB66";            
            else
              return ["#2A5377", "#88C658", "#44736E", "#71AA60", "#53856a"][seriesIndex % 5];
          }
        ],
        legend: {
          inverseOrder: true,
          offsetY: 20
        },
        responsive: [
          {
            breakpoint: 1370,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: "left"
              }
            }
          }
        ],
        stroke: {
          width: 0
        }
      }
    };
  },
  mounted() {
    if (localStorage.nivelVersao)
      this.nivelVersao = localStorage.nivelVersao;
  },
  methods: {
    filtering(ev){
      var self = this;

      localStorage.nivelVersao = self.nivelVersao;

      self.body = ev;

      clearInterval(self.mestreInterval);

      self.mestreInterval = false;

      self.initGraphics(self.sistemaAtual, false, ev);
      self.mestreInterval = setInterval(() => {
        self.initGraphics(self.sistemaAtual, false, self.body);
      }, 20000);
    },
    removeVersao(versao) {
      var self = this;
      self.versaoAtual.remove(versao);
      if (self.versaoAtual.length == 0) {
        self.clientesExibir = false;
        self.expandUVS = false;
      }
    },
    refreshFilter(){
      var self = this;
      clearInterval(self.mestreInterval);
      self.chartOptions.labels = [];
      self.series = [];

      self.initGraphics(self.sistemaAtual, true, self.body);
      self.mestreInterval = setInterval(() => {
        self.initGraphics(self.sistemaAtual, false, self.body);
      }, 20000);
    },
    initGraphics(ev, first, filters) {
      var self = this;
      var pArquivos = self.arquivos.map((e) => {
        return e.split(' (')[0];
      });      

      GraficosService.getDataGraphicVersoesSistemas(Number(ev), self.nivelVersao, {...filters, ...{atividades: self.atividades, personas: self.personas, analistas: self.analistas, arquivos: pArquivos}}).then(r => {
        var ar1 = [];
        var ar2 = [];
        var arrayAux = [];

        if (!r){
          self.originalVersaoArr = Object.assign([], r);
          return;
        }

        arrayAux = r.sort((a, b) => {
          var asp = a.CLISISVERSAOATUAL.split('.');
          var bsp = b.CLISISVERSAOATUAL.split('.');

          for (var i = 0; i <4; i++)
            if (asp.length <= i)
              return -1
            else if (bsp.length <= i)
              return 1
            else if (parseInt(asp[i]) != parseInt(bsp[i]))
              return parseInt(asp[i]) - parseInt(bsp[i])
        })
        
        self.originalVersaoArr = Object.assign([], arrayAux);

        arrayAux.forEach(element => {
          ar1.push(element.CLISISVERSAOATUAL);
          ar2.push(element.COUNT);
        });       
         
        if (!first && self.chartOptions.labels.length != ar1.length && self.series.length != ar2.length) {
          self.chartOptions.labels = [];
          self.series = [];
          setTimeout(() => {
            self.chartOptions.labels = ar1;
            self.series = ar2;
          }, 1);
        } else {
          if (self.chartOptions.labels.length == ar1.length && self.series.length == ar2.length) {

          } else {
            self.chartOptions.labels = ar1;
            self.series = ar2;
          }
        }
        
        self.loadingByReturns = false;
      });
    },
    grafSelect(event, chartContext, config) {
      var self = this;

      var index = Number(config.dataPointIndex);
      self.clientesExibir = true;
      if (event) {
        if (event.shiftKey) {
          var exist = false;          
          self.versaoAtual.forEach(el => {
            if (el == self.originalVersaoArr[index]) exist = true;
          });
          if (!exist) self.versaoAtual.push(self.originalVersaoArr[index]);
        } else {
          self.versaoAtual = Array();
          self.versaoAtual.push(self.originalVersaoArr[index]);
        }
        self.expandUVS = true;
      }
    }
  }
};
</script>
<style scoped>
.md-tabs-navigation {
  padding-left: 200px !important;
}
.md-card .md-tabs.md-success .md-tabs-navigation {
  padding-left: 139px !important;
}
.graphcontent {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
}
.graphcontent2 {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.md-layout-item {
  transition: all 0.5s ease-in-out !important;
}
div {
  transition: all 0.5s ease-in-out !important;
}
.vue-map-container {
  height: 82vh !important;
}
.alerta {
  margin: 46px;
  border: 1px solid #f90;
  padding: 10px;
  border-radius: 6px;
  color: #f90;
}
.nographic {
  width: 500px;
  display: flex;
  height: 300px;
  justify-content: center;
  align-items: center;
}
.apexcharts-toolbar {
  max-width: 400px;
}
.apexcharts-toolbar-custom-icon .custom-icon {
  width: 50px !important;
  margin-left: 10px;
}
div.apexcharts-toolbar-custom-icon {
  width: 60px;
  margin-left: 10px;
}

.apexcharts-zoom-icon, .apexcharts-zoomin-icon, .apexcharts-zoomout-icon, .apexcharts-reset-icon, .apexcharts-pan-icon, .apexcharts-selection-icon, .apexcharts-menu-icon, .apexcharts-toolbar-custom-icon {
    cursor: pointer;
    width: 220px !important;
    background: red;
    background-color: green !important;
    height: 20px;
    line-height: 24px;
    color: #6E8192;
    text-align: center;
}

</style>

